import { ErrorPageLayout } from '@/components/features/Errors/ErrorPageLayout';
import { Button } from '@/components/ui/shadcn/button';
import { useTranslations } from '@/hooks/useTranslations';
import { Head, Link } from '@inertiajs/react';
import { Home, SearchX } from 'lucide-react';

export default function NotFound() {
    const { t } = useTranslations();

    return (
        <>
            <Head title={t('errors.not_found.title', 'Page not found')} />
            <ErrorPageLayout
                icon={<SearchX />}
                code={t('errors.not_found.code', '404')}
                title={t('errors.not_found.title', 'Page not found')}
                description={t('errors.not_found.description', "The page you're looking for doesn't exist or is no longer available.")}
                actions={
                    <Button asChild>
                        <Link href="/">
                            <Home className="mr-2 h-4 w-4" />
                            {t('errors.not_found.back_home', 'Back to home')}
                        </Link>
                    </Button>
                }
            />
        </>
    );
}
